<template>
<v-expansion-panels class="my-10">
  <v-expansion-panel>
    <v-expansion-panel-header>
      <v-list>
        <v-list-item>
          <v-list-item-avatar>
            <v-icon x-large color="yellow">
              mdi-lightbulb-on-outline
            </v-icon>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title>{{title}}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-expansion-panel-header>
    <v-expansion-panel-content>
      <vue-markdown :source="markdown" class="markdown" :breaks="false"/>
    </v-expansion-panel-content>
  </v-expansion-panel>
</v-expansion-panels>
</template>

<script>
import VueMarkdown from 'vue-markdown'
export default {
  name: "ExtraBits",
  components: {
    VueMarkdown
  },
  props: [
      'title',
      'content',
      'markdown'
  ]
}
</script>

<style scoped>

</style>